import type { FaireProductEntity } from "../../entity_types/product";

export const p_hhd2k2q77z: FaireProductEntity = {
  token: "p_hhd2k2q77z",
  type: "product",
  name: "Jasmine Magnolia Pearls",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/119dd003ee5cdd3df4aa6312e07f67c1f9c3ca1de5d22dc8a6628c23ab566fa7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/066971bd41e8c8d6e079ab8ba9cb58c182353375fa78feca5cdc4322ea66290f.jpeg",
    "https://cdn.faire.com/fastly/3096e50d08cb9400b2c3f524cdd352a2bfe0edf142a0cfed9cecec13cd41643e.png"
  ],
  priceDollars: 19.6,
  description: "\nProfile: Smooth, floral, ethereal. It starts with carefully plucked spring green tea and after an intricate drying process with harvested jasmine and magnolias, we're presented with an elegant yet satisfying floral cup. \n\n\n\n\nProfile: Smooth, floral, ethereal\n\n\n\nTeas of this quality are getting harder to source and the prices justifiably rising. It starts with carefully plucked spring green tea, left with longer stems so they can be twisted together as the beginning of each hand-rolled pearl. After drying, the pearls are stored until summer when jasmine and magnolias are in bloom. This is when the magic happens. The flowers are harvested and layered in with the tea pearls overnight. In the hot summer air the intoxicating aromas transfer onto the tea leaves, which are dried again to capture that essence rare. \n\n\n\nWe recommend brewing 1g of tea for 2oz of water at 200° for 3 minutes.\n\n\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:59.033Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
